import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import Image from '../../Image/Image';
import styles from './Cover.module.css';

const cx = classNames.bind(styles);

/**
 * `PropTypes.node` infers as `ReactNodeLike`, and a JSX element is not assignable
 * to it — so without these annotations every caller handing markup to `overlay`,
 * `children` or `decorations` is an error.
 *
 * @param {{
 *   src: string,
 *   mobileSrc?: string | null,
 *   containerClassName?: string,
 *   className?: string,
 *   imageClassName?: string,
 *   opacity?: number | null,
 *   overlay?: import('react').ReactNode,
 *   children?: import('react').ReactNode,
 *   decorations?: import('react').ReactNode,
 * }} props
 */
const Cover = ({
  src,
  mobileSrc,
  containerClassName,
  className,
  imageClassName,
  opacity,
  overlay,
  children,
  decorations,
}) => (
  <div className={cx('cover-container', containerClassName)}>
    <div className={cx('image-container', className)}>
      <Image src={src} className={cx(imageClassName)} />
    </div>
    <div className={cx('mobile-image-container', className)}>
      <Image src={mobileSrc || src} className={cx(imageClassName)} />
    </div>

    {opacity && <div className={cx('cover-overlay')} style={{ opacity }} />}
    {overlay}

    {children && <div className={cx('cover-content')}>{children}</div>}
    {decorations}
  </div>
);

Cover.propTypes = {
  className: PropTypes.string,
  imageClassName: PropTypes.string,
  containerClassName: PropTypes.string,
  overlay: PropTypes.node,
  src: PropTypes.string.isRequired,
  mobileSrc: PropTypes.string,
  children: PropTypes.node,
  opacity: PropTypes.number,
  decorations: PropTypes.node,
};

Cover.defaultProps = {
  className: '',
  imageClassName: '',
  containerClassName: '',
  overlay: null,
  mobileSrc: null,
  children: null,
  opacity: null,
  decorations: null,
};

export default Cover;
